/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC } from 'react';

export type LabelProps = {
  style?: any;
  content: any | string;
  className?: string;
};

const Label: FC<LabelProps> = (props) => {
  const { style, content, className } = props;

  return <div {...{ className, style }}>{content}</div>;
};

export default Label;
